var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Checkbox',{attrs:{"binary":true},model:{value:(_vm.localIncludeTax),callback:function ($$v) {_vm.localIncludeTax=$$v},expression:"localIncludeTax"}}),_c('span',{staticClass:"px-2"},[_vm._v("Tax")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }